import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { SystemInputsTypes } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
export const fetchInputTypes = async () => await SystemInputsTypes.all();
const useInputTypesDescriptions = ({ enabled } = { enabled: true }) => {
  const { data, refetch, isLoading } = useQuery({
    queryKey: ["inputTypes", "all"],
    queryFn: () => defaultOnError(
      fetchInputTypes(),
      "Loading input types descriptions failed with status",
      "Could not load input types descriptions"
    ),
    placeholderData: keepPreviousData,
    enabled
  });
  return { data: data || {}, refetch, isLoading };
};
export default useInputTypesDescriptions;
